module.exports = __webpack_public_path__ + "img/aeroland-client-logo-07.1808ce8b.png";